import iconStyles from "../../../components/Icon.module.scss";
import buttonStyles from "../../../components/Button.module.scss";
import cardStyles from "../../../components/Card.module.scss";
import styles from "./Programs.module.scss";
import { useRef, useState } from "react";

const Programs = () => {
  const CARD_WIDTH = 320;
  const CARD_GAP = 16;
  const SCROLL_STEP = CARD_WIDTH + CARD_GAP;

  const cardContainerRef = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);
  const [prevOffset, setPrevOffset] = useState(0);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const handleNext = () => {
    const container = cardContainerRef.current;
    if (!container) return;

    const containerWidth = container.offsetWidth;
    const totalWidth = container.scrollWidth;

    if (offset === totalWidth - containerWidth) {
      return;
    }

    let newOffset = offset + SCROLL_STEP;

    if (newOffset > totalWidth - containerWidth) {
      const forPrevOffset = totalWidth - containerWidth - offset;
      setPrevOffset(forPrevOffset);
      newOffset = totalWidth - containerWidth;
      setAtEnd(true);
    }

    setOffset(newOffset);
    container.style.transform = `translateX(-${newOffset}px)`;
    setAtStart(newOffset <= 0 ? true : false);
  };

  const handlePrev = () => {
    const container = cardContainerRef.current;
    if (!container) return;

    let newOffset = offset - SCROLL_STEP;
    if (newOffset < 0) newOffset = 0;
    if (prevOffset > 0) {
      newOffset = offset - prevOffset;
      setPrevOffset(0);
    }

    setOffset(newOffset);
    container.style.transform = `translateX(-${newOffset}px)`;
    setAtEnd(false);
    setAtStart(newOffset === 0);
  };

  return (
    <section id="programs" className={styles.programs}>
      <div className={styles.title}>
        <h5>Regular programs</h5>
        <div className={styles.nav}>
          <div
            className={`${buttonStyles.btn} ${
              atStart ? "" : buttonStyles.active
            }`}
            id="prev-program-btn"
            onClick={handlePrev}
          >
            <span
              className={`${iconStyles.icon} ${styles.icon} ${iconStyles.prev}`}
            ></span>
          </div>
          <div
            className={`${buttonStyles.btn} ${
              atEnd ? "" : buttonStyles.active
            }`}
            id="next-program-btn"
            onClick={handleNext}
          >
            <span
              className={`${iconStyles.icon} ${styles.icon} ${iconStyles.next}`}
            ></span>
          </div>
        </div>
      </div>
      <div className={cardStyles.list}>
        <div ref={cardContainerRef} className={cardStyles["card-container"]}>
          <div className={cardStyles.card}>
            <h6>
              Sunday service
              <br />
              &amp; Sunday school
            </h6>
            <div className={cardStyles.subtitle}>
              Every Sunday, <span className={cardStyles.time}>10:00 AM</span>
            </div>
          </div>
          <div className={cardStyles.card}>
            <h6>
              Choir
              <br />
              practice
            </h6>
            <div className={cardStyles.subtitle}>
              Every Sunday,{" "}
              <span className={cardStyles.time}>12:30-13:45 PM</span>
            </div>
          </div>
          <div className={cardStyles.card}>
            <h6>Home fellowship</h6>
            <div className={cardStyles.subtitle}>Saturday (Monthly)</div>
          </div>
          <div className={cardStyles.card}>
            <h6>
              In-person prayer
              <br />
              fellowship
            </h6>
            <div className={cardStyles.subtitle}>
              Last Friday of the month,{" "}
              <span className={cardStyles.time}>6:00 PM</span>
            </div>
          </div>
          <div className={cardStyles.card}>
            <h6>
              Online prayer
              <br />
              fellowship
            </h6>
            <div className={cardStyles.subtitle}>
              Friday, <span className={cardStyles.time}>7:00 PM</span>
            </div>
          </div>
          <div className={cardStyles.card}>
            <h6>
              Bible study
              <br />
              for male
            </h6>
            <div className={cardStyles.subtitle}>
              Wednesday & Thursday (Bi-weekly)
            </div>
          </div>
          <div className={cardStyles.card}>
            <h6>
              Bible study
              <br />
              for female
            </h6>
            <div className={cardStyles.subtitle}>
              Monday & Tuesday (Bi-weekly)
            </div>
          </div>
        </div>
      </div>
      <div className={styles.contact}>
        <h6>
          Contact us for details
          <br />
          of the programs
        </h6>
        <div className={styles.wrapper}>
          <a
            href="https://www.facebook.com/people/PRII-Stockholm-IREC-Stockholm/100089208450489/?locale2=en"
            className={`${buttonStyles["icon-button"]}`}
            target="_blank"
            rel="noreferrer"
          >
            <i
              className={`${iconStyles.icon} ${styles.icon} ${iconStyles.facebook}`}
            ></i>
          </a>
          <a
            href="https://www.instagram.com/irec.stockholm"
            className={`${buttonStyles["icon-button"]}`}
            target="_blank"
            rel="noreferrer"
          >
            <i
              className={`${iconStyles.icon} ${styles.icon} ${iconStyles.instagram}`}
            ></i>
          </a>
          <a
            href="https://www.youtube.com/channel/UCJGpw2y2fAQ97CMXRpdPGMw"
            className={`${buttonStyles["icon-button"]}`}
            target="_blank"
            rel="noreferrer"
          >
            <i
              className={`${iconStyles.icon} ${styles.icon} ${iconStyles.youtube}`}
            ></i>
          </a>
          <a
            href="mailto:irec.stockholm@gmail.com"
            className={`${buttonStyles["icon-button"]}`}
            target="_blank"
            rel="noreferrer"
          >
            <i
              className={`${iconStyles.icon} ${styles.icon} ${iconStyles.email}`}
            ></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Programs;
